import { render, staticRenderFns } from "./TableDataManagementTable.vue?vue&type=template&id=48673b86&"
import script from "./TableDataManagementTable.vue?vue&type=script&lang=js&"
export * from "./TableDataManagementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports